import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 dtwin-form",
    style: !_vm.twinCanBeEdited ? 'opacity: 0.9' : '',
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.unsavedTitle'),
      "open": _vm.unsavedPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptConfirm'),
        color: 'danger',
        emit: 'discard-changes'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.unsavedPrompt = false;
      },
      "discard-changes": function ($event) {
        return _vm.unsavePromptNextPersist();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.unsavedText')) + "\n  ")]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisableConfirmation'),
      "open": _vm.disableDialog,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable'),
        color: 'red',
        emit: 'disable'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.disableDialog = false;
      },
      "disable": _vm.dialogDisable
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisableConfirmText'))
    }
  })]), _c(VForm, {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.prepareSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VRow, {
    staticClass: "pb-0 mx-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.showHeaderMap ? _c('core-dtwin-map-header-map', {
    style: `width: 100%; ${!_vm.twinCanBeEdited ? 'opacity: 0.5' : ''}`,
    attrs: {
      "geoCoordinates": _vm.dtwinCoordinates,
      "geoPolygon": _vm.dtwinPolygon,
      "dtwTitle": _vm.twinObject.title,
      "dtwData": _vm.twinObject.data,
      "mapInteractive": false,
      "overlayInfo": _vm.dtwinOverlayInfo,
      "header": ""
    },
    on: {
      "polygonUpdated": _vm.dtwinGeopolygonUpdated,
      "markerUpdated": _vm.dtwinCoordinateUpdated
    }
  }) : _c(VCol, {
    staticClass: "pa-0"
  }, [_c(VParallax, {
    style: `width: 100%; ${!_vm.twinCanBeEdited ? 'opacity: 0.5' : ''}`,
    attrs: {
      "height": "240",
      "src": _vm.headerBG
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 header-text dtwin-title-frame text-truncate"
  }, [_vm.twinObject.data.faIcon && _vm.twinObject.data.faIcon.trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.twinObject.data.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.twinObject.title) + "\n          ")], 1)])], 1)], 1), _c('div', _vm._b({}, 'div', _vm.actionBoxClass, false), [_c('div', {
    class: `px-2 ${_vm.actionBoxGradientClass}`,
    staticStyle: {
      "height": "60px"
    }
  }, [_vm.twinObject.properties && _vm.twinObject.properties.disabled ? _c('div', {
    staticClass: "ml-1 mr-1 v-btn danger--text",
    staticStyle: {
      "float": "left",
      "margin": "10px auto",
      "line-height": "47px",
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisabled')) + "\n        ")]) : _vm._e(), !_vm.parentIsDisabled ? [!_vm.isMobile ? _c('span', [_vm.hasTwinManagePermission && _vm.twinCanBeEdited ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable'),
      "color": "danger",
      "disabled": _vm.cloading,
      "prepend-icon": "fa-lightbulb-slash"
    },
    on: {
      "click": function ($event) {
        _vm.disableDialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable')))]) : _vm.hasTwinManagePermission ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinEnable'),
      "color": _vm.color,
      "disabled": _vm.cloading,
      "prepend-icon": "fa-lightbulb-on"
    },
    on: {
      "click": _vm.dtwinToggleState
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinEnable')))]) : _vm._e()], 1) : _c('span', [_vm.hasTwinManagePermission && _vm.twinCanBeEdited ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable'),
      "color": "danger",
      "disabled": !_vm.valid || _vm.cloading,
      "prepend-icon": "fa-lightbulb-slash"
    },
    on: {
      "click": function ($event) {
        _vm.disableDialog = true;
      }
    }
  }) : _vm.hasTwinManagePermission ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinEnable'),
      "color": _vm.color,
      "disabled": !_vm.valid || _vm.cloading,
      "prepend-icon": "fa-lightbulb-on"
    },
    on: {
      "click": _vm.dtwinToggleState
    }
  }) : _vm._e()], 1)] : _vm._e(), _c('core-favoriteselect', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "objectId": _vm.twinObject.id,
      "type": "digitalTwin",
      "asRoundButton": ""
    }
  }), _vm.twinObject && _vm.twinObject.id ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMap'),
      "color": _vm.color,
      "prepend-icon": "fa-map-marked"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          path: '/digitaltwin-mgmt/map/twin/' + _vm.twinObject.id
        });
      }
    }
  }) : _vm._e(), _vm.twinCanBeEdited ? _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('Common.save'),
      "color": _vm.color,
      "solid-icon": "",
      "disabled": !_vm.valid || _vm.cloading,
      "prepend-icon": "fa-save",
      "type": "submit"
    }
  }) : _vm._e(), _vm.twinObject && _vm.twinObject.id ? _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "min-width": "320px",
      "max-height": "500px",
      "nudge-left": "12",
      "offset-y": "",
      "offset-x": "",
      "absolute": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c('core-button', _vm._g({
          attrs: {
            "title": _vm.$i18n_t('Common.digitalTwins.selectTwin'),
            "color": _vm.color,
            "disabled": _vm.cloading,
            "prepend-icon": "fa-sitemap"
          }
        }, on))];
      }
    }], null, false, 1833204502),
    model: {
      value: _vm.twinSelectionTreeMenu,
      callback: function ($$v) {
        _vm.twinSelectionTreeMenu = $$v;
      },
      expression: "twinSelectionTreeMenu"
    }
  }, [_c(VCard, [_c('core-dtwin-tree-default', {
    attrs: {
      "userId": _vm.sessionUserId,
      "activeDtwinId": _vm.twinObject ? _vm.twinObject.id : undefined,
      "searchEnabled": false,
      "cached": "",
      "loadFullDtwinData": "",
      "canSelectDisabledTwins": ""
    },
    on: {
      "onSelectedChange": _vm.digitalTwinChanged
    }
  })], 1)], 1) : _vm._e(), _c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('Common.cancel'),
      "color": "danger",
      "disabled": _vm.cloading,
      "prepend-icon": "fa-times"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          path: `/${_vm.baseLink}`,
          query: {
            openTree: _vm.openTree,
            active: _vm.activeId
          }
        });
      }
    }
  })], 2)]), _c(VRow, {
    staticClass: "n20-mainrow pb-4 pt-1",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VCard, {
    staticClass: "mb-8"
  }, [_c(VCardText, [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-dashboard"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-tachometer-alt")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.drawer.twinDashboard')) + "\n              ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-main"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-file-alt")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinInformation')) + "\n              ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-details"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-list")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.digitalTwins.dtwinDetails')) + "\n              ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-assetinfo"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-sensor-on")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('IS.AssetMgmt.details.assetInfo')) + "\n              ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-states"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-network-wired")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataStates')) + "\n              ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-rules"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-sparkles")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.tabItem')) + "\n              ")], 1), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "dashboard",
    attrs: {
      "value": "tab-dashboard"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-sensor-on",
      "title": _vm.$i18n_t('IS.AssetMgmt.details.assetInfo'),
      "offset": 24
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('Common.id'),
      "value": _vm.twinObject.id,
      "iconColor": _vm.color,
      "icon": "file-excel",
      "type": "icon"
    }
  })], 1), _vm.twinObject.data.assetManagement ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.operationalStatus'),
      "value": _vm.operationalStatus[parseInt(_vm.twinObject.data.assetManagement.operationalStatus)] || _vm.twinObject.data.assetManagement.operationalStatus,
      "iconColor": _vm.color,
      "icon": "heart-rate",
      "type": "icon"
    }
  })], 1) : _vm._e(), _vm.mapHistoryLastUpdate ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('IS.AssetMgmt.list.lastSeen'),
      "value": _vm.localizeDate(_vm.mapHistoryLastUpdate.date),
      "iconColor": _vm.color,
      "icon": "map-marker-check",
      "type": "icon"
    }
  })], 1) : _vm._e(), _vm.mapHistoryLastUpdate && _vm.mapHistoryLastUpdate.floorDtwin ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
      "value": _vm.mapHistoryLastUpdate.floorDtwin.title,
      "iconColor": _vm.color,
      "icon": "level-up-alt",
      "type": "icon"
    },
    scopedSlots: _vm._u([{
      key: "value",
      fn: function () {
        return [_c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${_vm.mapHistoryLastUpdate.floorDtwin.id}`
          }
        }, [_vm._v("\n                              " + _vm._s(_vm.mapHistoryLastUpdate.floorDtwin.title) + "\n                            ")])];
      },
      proxy: true
    }], null, false, 122575506)
  })], 1) : _vm._e(), _vm.deviceData.length && _vm.deviceData[0].properties && _vm.deviceData[0].properties.operational_status ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('IS.AssetMgmt.list.device'),
      "value": _vm.operationalStatus[parseInt(_vm.deviceData[0].properties.operational_status.value)],
      "iconColor": _vm.color,
      "icon": "sensor-on",
      "type": "icon"
    },
    scopedSlots: _vm._u([{
      key: "value",
      fn: function () {
        return [_c('router-link', {
          attrs: {
            "to": `/niota-classic/devices/${_vm.deviceData[0].deviceId}/details`
          }
        }, [_vm._v("\n                              " + _vm._s(_vm.operationalStatus[parseInt(_vm.deviceData[0].properties.operational_status.value)]) + "\n                            ")])];
      },
      proxy: true
    }], null, false, 4059155011)
  })], 1) : _vm._e(), _vm.deviceData.length && _vm.deviceData[0].batteryLevel !== undefined ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.battery'),
      "value": _vm.getBatteryLevel(_vm.deviceData[0]),
      "iconColor": _vm.color,
      "icon": "battery-bolt",
      "type": "icon"
    }
  })], 1) : _vm._e()], 1)], 1), _c('core-dtwin-state-preview-db-tiles', {
    staticClass: "mt-4",
    style: !_vm.twinCanBeEdited ? 'opacity: 0.65' : '',
    attrs: {
      "twinDataStates": _vm.twinDataStates,
      "updatedStates": _vm.updatedStates,
      "loading": _vm.isLoadingStates,
      "noDataAlert": ""
    },
    on: {
      "didUpdateStates": _vm.didUpdateStates
    }
  })], 1), _c(VTabItem, {
    key: "main",
    attrs: {
      "value": "tab-main"
    }
  }, [_c('core-dtwin-edit-information', {
    attrs: {
      "twinObject": _vm.twinObject,
      "hasTwinManagePermission": _vm.hasTwinManagePermission && _vm.twinCanBeEdited,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "hasUserReadPermission": _vm.permissions['UserManagement.read'],
      "hasVisibleParent": _vm.hasVisibleParent,
      "hideFields": ['type']
    },
    on: {
      "scope-updated": function ($event) {
        return _vm.setup();
      }
    }
  })], 1), _c(VTabItem, {
    key: "details",
    attrs: {
      "value": "tab-details"
    }
  }, [_vm.twinObject.id ? _c(VRow, [_c(VCol, [_c('core-dtwin-geo-details', {
    attrs: {
      "dataInstance": _vm.wrappedInstance,
      "twinObject": _vm.twinObject,
      "twinImages": _vm.twinImages,
      "twinCanBeEdited": _vm.twinCanBeEdited,
      "hasFloorTwinReadPermissions": _vm.hasFloorTwinReadPermissions,
      "floorTwinOverlayData": _vm.floorTwinOverlayData
    }
  })], 1)], 1) : _vm._e()], 1), _c(VTabItem, {
    key: "states",
    attrs: {
      "value": "tab-states"
    }
  }, [_vm.twinObject.tenantId ? _c('core-dtwin-state-table', {
    ref: "stateTable",
    attrs: {
      "updatedStates": _vm.updatedStates,
      "disabled": _vm.dtwinIsDisabled,
      "hasTwinManagePermission": _vm.twinCanBeEdited && _vm.hasTwinManagePermission,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "tenantId": _vm.twinObject.tenantId,
      "twinModel": _vm.twinObject,
      "isVirtualDevice": false
    },
    on: {
      "statesUpdated": _vm.refreshStates,
      "refresh": _vm.refreshStates,
      "finishedLoading": _vm.finishedLoadingStatesTable
    },
    model: {
      value: _vm.twinDataStates,
      callback: function ($$v) {
        _vm.twinDataStates = $$v;
      },
      expression: "twinDataStates"
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: "assetinfo",
    attrs: {
      "value": "tab-assetinfo"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_vm.twinObject.data.assetManagement ? _c(VCombobox, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.operationalStatus'),
      "items": _vm.operationalStatusItems,
      "return-object": false,
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function () {
        return [_vm.operationalStatus[parseInt(_vm.twinObject.data.assetManagement.operationalStatus)] ? [_vm._v("\n                            " + _vm._s(_vm.operationalStatus[parseInt(_vm.twinObject.data.assetManagement.operationalStatus)]) + "\n                          ")] : [_vm._v("\n                            " + _vm._s(_vm.twinObject.data.assetManagement.operationalStatus) + "\n                          ")]];
      },
      proxy: true
    }], null, false, 2614364337),
    model: {
      value: _vm.twinObject.data.assetManagement.operationalStatus,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data.assetManagement, "operationalStatus", $$v);
      },
      expression: "twinObject.data.assetManagement.operationalStatus"
    }
  }) : _vm._e(), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('IS.AssetMgmt.details.assetStatusDescription')) + "\n                      ")])], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description mt-2 mb-0 pb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('IS.AssetMgmt.edit.trackerDeviceDescription'))
    }
  })]), ((_vm.twinObject.data.assetManagement || {}).deviceIds || []).length === 0 ? _c(VCol, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        _vm.deviceData = [];
        _vm.addNewDevice(-1);
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('IS.AssetMgmt.edit.addDevice')) + "\n                      ")])], 1) : _vm._e(), _vm.deviceData.length === 0 && ((_vm.twinObject.data.assetManagement || {}).deviceIds || []).length > 0 ? _c(VCol, [_c(VSimpleTable, [_c('tbody', _vm._l(_vm.twinObject.data.assetManagement.deviceIds, function (id, i) {
    return _c('tr', {
      key: `asset-device-${i}`
    }, [_c('td', [_c(VSkeletonLoader, {
      attrs: {
        "type": "heading"
      }
    })], 1), _c('td', [_c(VSkeletonLoader, {
      attrs: {
        "type": "heading"
      }
    })], 1), _c('td', [_c(VSkeletonLoader, {
      attrs: {
        "type": "heading"
      }
    })], 1)]);
  }), 0)])], 1) : _vm.deviceData.length > 0 && ((_vm.twinObject.data.assetManagement || {}).deviceIds || []).length > 0 ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSimpleTable, [_c('thead', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$i18n_t('Common.id')))]), _c('td', [_vm._v("Name")]), _c('td', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.operationalStatus')))]), _c('td', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.battery')))]), _c('td')])]), _c('tbody', _vm._l(_vm.deviceData, function (deviceId, i) {
    return _c('tr', {
      key: `asset-device-${i}`
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(_vm.deviceData[i].deviceId))]), _c('td', {
      staticClass: "text-left"
    }, [_vm.deviceData[i].deviceId ? [_c('a', {
      attrs: {
        "href": `/#/niota-classic/devices/${_vm.deviceData[i].deviceId}/details`,
        "target": "_blank"
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.deviceData[i].deviceTitle) + "\n                                ")])] : _vm._e()], 2), _c('td', {
      staticClass: "text-left"
    }, [_vm.deviceData[i].properties && _vm.deviceData[i].properties.operational_status ? [_vm._v("\n                                " + _vm._s(_vm.operationalStatus[_vm.deviceData[i].properties.operational_status.value]) + "\n                              ")] : _vm._e()], 2), _c('td', {
      staticClass: "text-left"
    }, [_vm.deviceData[i].batteryLevel !== undefined ? _c('custom-fields-display-field', {
      attrs: {
        "label": _vm.$i18n_t('NiotaClassic.Devices.details.battery'),
        "value": _vm.getBatteryLevel(_vm.deviceData[i]),
        "iconColor": _vm.color,
        "icon": "battery-bolt",
        "type": "icon"
      }
    }) : _vm._e()], 1), _c('td', {
      staticStyle: {
        "min-width": "340px"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "label": _vm.$i18n_t('IS.AssetMgmt.edit.trackerDevice'),
        "disabled": _vm.isLoading,
        "loading": !_vm.deviceData[i].deviceId,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.euiRules,
        "hide-details": "auto",
        "clearable": "",
        "required": ""
      },
      on: {
        "change": function ($event) {
          return _vm.fetchIotHubDetails(i);
        }
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('core-button', {
            attrs: {
              "disabled": _vm.isLoading,
              "color": _vm.color,
              "prepend-icon": "fa-trash-alt"
            },
            on: {
              "click": function ($event) {
                return _vm.removeDevice(i);
              }
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.deviceData[i].deviceEui,
        callback: function ($$v) {
          _vm.$set(_vm.deviceData[i], "deviceEui", $$v);
        },
        expression: "deviceData[i].deviceEui"
      }
    }), _c(VInput, {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "rules": _vm.requiredRule
      },
      model: {
        value: _vm.deviceData[i].deviceId,
        callback: function ($$v) {
          _vm.$set(_vm.deviceData[i], "deviceId", $$v);
        },
        expression: "deviceData[i].deviceId"
      }
    })], 1)]);
  }), 0)])], 1) : _vm._e()], 1)], 1), _c(VTabItem, {
    key: "rules",
    attrs: {
      "value": "tab-rules"
    }
  }, [_vm.twinObject.tenantId ? _c('core-dtwin-rule-table', {
    ref: "rulesTable",
    attrs: {
      "stateTable": _vm.$refs.stateTable,
      "disabled": _vm.dtwinIsDisabled,
      "hasTwinManagePermission": _vm.twinCanBeEdited && _vm.hasTwinManagePermission,
      "hasTwinEditPermission": _vm.twinCanBeEdited,
      "dtwinId": _vm.twinObject.id,
      "tenantId": _vm.twinObject.tenantId,
      "dtwin": _vm.twinObject
    },
    model: {
      value: _vm.twinDataStates,
      callback: function ($$v) {
        _vm.twinDataStates = $$v;
      },
      expression: "twinDataStates"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };